// @flow
import { createValidator, required, maxLength } from 'gandi.react-form';

const MAXLENGTH = 255;

export default (createValidator({
  authinfo: [required, maxLength(MAXLENGTH)],
}): any);
